import Button from '../Button'
import Icon from '../Icon'
import { HeroArt } from '../art/LineArt'
import { hy } from '../../lib/typography'

/**
 * Home page hero.
 *
 * The original opened with a background video behind the claim and a "Play
 * Video" button. That file was 404 like every other upload; the film is back on
 * the page now (see FilmSection), but as something to watch rather than
 * decoration behind text, so the hero keeps the drawn elevation.
 */

const TRUST = [
  { icon: 'clock', label: 'Antwort innerhalb eines Werktages' },
  { icon: 'pin', label: 'Regional vor Ort in Aldingen' },
  { icon: 'shield', label: 'Zugelassen nach § 34c GewO' },
]

/** The small panel over the illustration. */
const PANEL = [
  { label: 'Reaktionszeit', value: 'max. 1 Werktag', accent: true },
  { label: 'Verwaltungsarten', value: 'WEG · SEV · Miete' },
  { label: 'Kunden-App', value: 'iDWELL' },
]

export default function Hero() {
  return (
    <section className="hero on-dark">
      <div className="blueprint" aria-hidden="true" />
      <div
        className="glow glow--gold float-slow"
        aria-hidden="true"
        style={{ width: '32rem', height: '32rem', right: '-6rem', top: '-6rem' }}
      />

      <div className="container">
        <div className="hero__grid">
          <div className="hero__copy">
            <p className="eyebrow">Hausverwaltung für die Region</p>

            <h1 className="hero__title">
              {/* At the smallest widths the display size makes even
                  "Hausverwaltung" wider than the column. */}
              {hy('Haus', 'verwaltung')}.<em>Besser gemacht.</em>
            </h1>

            <p className="hero__lead">
              CASA ist Ihr kompetenter, schneller und zuverlässiger Partner. Wir
              übernehmen WEG-Verwaltung, Sondereigentum und Mietverwaltung -
              regional, digital und mit Rückmeldung innerhalb eines Werktages.
            </p>

            <div className="btn-row">
              <Button to="/kontakt" size="lg" icon="arrowRight">
                Kostenloses Erstgespräch
              </Button>
              <Button to="/leistungen" size="lg" variant="ghost-dark">
                Leistungen ansehen
              </Button>
            </div>

            <div className="hero__trust">
              {TRUST.map((item) => (
                <p className="hero__trust-item" key={item.label}>
                  <Icon name={item.icon} />
                  {item.label}
                </p>
              ))}
            </div>
          </div>

          <div className="hero__visual">
            <HeroArt />

            <div className="hero__panel">
              {PANEL.map((row) => (
                <div className="hero__panel-row" key={row.label}>
                  <span className="hero__panel-label">{row.label}</span>
                  <span
                    className={`hero__panel-value${
                      row.accent ? ' hero__panel-value--gold' : ''
                    }`}
                  >
                    {row.value}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
